import React from 'react';
import BaseIcon from './BaseIcon';

interface ArrowRightIconProps {
  className?: string;
}

const ArrowRightIcon: React.FC<ArrowRightIconProps> = ({ className = "w-5 h-5" }) => (
  <BaseIcon className={className} strokeWidth={2}>
    <path d="M5 12h14"></path>
    <path d="m12 5 7 7-7 7"></path>
  </BaseIcon>
);

export default ArrowRightIcon;
